<mat-dialog-content class="custom-dialog-container" style="flex: 1; overflow: auto;">   
  
  <div class="dialog-content">
    <div class="parameter-section">
      <h3>Identificação</h3>

      <div class="input-group">
        <label>Nome da Integração:</label>
        <input [(ngModel)]="configName" placeholder="Digite o nome da integração" />
      </div>
    </div>
      <div *ngIf="data?.entity?.IDRULE" class="parameter-section">
        <h3>Imagem da Configuração</h3>
        
        <div style="display: flex; align-items: center; gap: 20px;">
          <img [src]="imagePreview" style="max-height: 100px; border: 1px solid #ccc; padding: 5px;" />
          <button mat-raised-button color="primary" (click)="triggerImageUpload()">Selecionar Imagem</button>
          <input type="file" #fileInput hidden accept="image/*" (change)="handleImageUpload($event)">
        </div>
      </div>
        <div class="parameter-section">      
          <h3>Parâmetros</h3>
        <div *ngFor="let param of config.parameters; let i = index" class="parameter-block">
          <fieldset>
            <legend>Parâmetro {{'@'}}{{ param.PARNAME || 'SEM_NOME' }}</legend>


            <div class="input-group">
              <input [(ngModel)]="param.PARNAME" placeholder="Nome do Parâmetro" />
              <select [(ngModel)]="param.TYPE" (ngModelChange)="onParameterTypeChange(param, $event)">
                <option value="F">Fixo</option>
                <option value="I">Input do Usuário</option>
                <option value="D">Arquivo</option>
                <option value="J">JSON</option>
                <option value="R">Request</option>
                <option value="FM">Fórmula</option>
                <option value="S">Busca de Dados</option>
              </select>
            </div>

            <div class="input-group" *ngIf="param.TYPE === 'F' || param.TYPE === 'J'">
              <label>Valor do Parâmetro</label>
              <input [(ngModel)]="param.VALUE" placeholder="Valor do Parâmetro" />
            </div>
            <div class="input-group" *ngIf="param.TYPE === 'S'">
              <search-input-new [(ngModel)]="param.ENTITYNAME" (onChangeData)="onEntityNameChange(param)" [searchProperties]="searchMktpDic"></search-input-new>  
               <search-input-new [(ngModel)]="param.KEYFIELD" [searchProperties]="searchKeyDic" *ngIf="!hiddenKeyField || param.KEYFIELD!= null"></search-input-new>  
               <search-input-new [(ngModel)]="param.VALUEFIELD" [searchProperties]="searchNameDic" *ngIf="!hiddenValueField || param.VALUEFIELD!= null"></search-input-new>  
            </div>
            <div class="input-group" *ngIf="param.TYPE === 'FM'">
              <label>Fórmula</label>
              <textarea [(ngModel)]="param.FORMULA" rows="3" placeholder="Digite a fórmula que será executada no servidor"></textarea>
            </div>

            <div class="service-config" *ngIf="param.TYPE === 'R' && param.requestConfig">
              <button mat-icon-button class="btn-service" (click)="openRequestConfig(param)" title="Configurar Request">
                <mat-icon>settings</mat-icon>
              </button>
              <span>Serviço: {{ param.requestConfig.serviceName }}</span>
            </div>

            <button (click)="config.parameters.splice(i, 1)" class="remove-btn">Remover</button>
          </fieldset>
          </div>

            <button (click)="addParameter()" class="add-btn">Adicionar Parâmetro</button>
          </div>
          
          <div class="table-section">
            <h3>Tabelas</h3>
            <ng-container *ngTemplateOutlet="tableTemplate; context: { $implicit: config.config, level: 0 }"></ng-container>
          </div>
          
          <ng-template #tableTemplate let-tables let-level="level">
            <div *ngFor="let table of tables" class="table-row" [style.marginLeft.px]="level * 20" [style.borderLeft]="level > 0 ? '2px solid #ccc' : 'none'">
              <div class="table-header">
                <div class="input-group">
                  <label>Nome da Tabela:</label>
                  <input [(ngModel)]="table.NAME" placeholder="Nome da Tabela">
                  
                </div>
               <div class="input-group">
                <label>Fórmula DATAORIG:</label>
                <input [(ngModel)]="table.DATAORIG" placeholder="Ex: @DATAIN ou arrayToObject(@JSON,x)">
               </div>

              <div class="input-group">
                <label>Filtro (opcional):</label>
                <input [(ngModel)]="table.FILTER" placeholder="Ex: @DATAIN_ROW.id > 10">
              </div>
                <div class="formula">
                    <button mat-icon-button (click)="openEditFormula(table, 'D')">
                        <mat-icon class="marginLeftIcon">more_vert</mat-icon>
                    </button>        
                </div>        
                <button (click)="addColumn(table)" class="add-column-btn">Adicionar Coluna</button>
                <button (click)="addTable(table)" class="add-table-btn">Adicionar Tabela Filha</button>
                <button mat-icon-button color="warn" (click)="removeTable(tables, table)">
                  <mat-icon class="marginLeftIcon">delete</mat-icon>
                </button>
              </div>
          
              <div class="columns-section">
                <h4>Colunas</h4>
                <div *ngFor="let column of table.COLUMNS" class="column-row">
                  <div class="input-group">
                    <label>Nome:</label>
                    <input [(ngModel)]="column.columnName" placeholder="Nome da Coluna">
                  </div>
                  <div class="input-group">
                    <label>Tipo:</label>
                    <select [(ngModel)]="column.type">
                      <option value="PARAM">Parâmetro</option>
                      <option value="FORMULA">Fórmula</option>
                      <option value="FIXED">Fixo</option>                      
                      <option value="JSON">JSON</option>                      
                    </select>
                  </div>
                  <div class="input-group">
                    <label>Valor:</label>
                    <input [(ngModel)]="column.value" placeholder="Valor/Fórmula">                        
                  </div>
                  <div class="formula">
                    <button mat-icon-button (click)="openEditFormula(column, 'V')">
                        <mat-icon class="marginLeftIcon">more_vert</mat-icon>
                    </button>    
                  </div>
                  <button mat-icon-button color="warn" (click)="removeColumn(table, column)">
                    <mat-icon class="marginLeftIcon">delete</mat-icon>
                  </button>
                </div>
              </div>
          
              <div class="child-tables">
                <h4 *ngIf="table.CHILD?.length">Tabelas Filhas</h4>
                <ng-container *ngTemplateOutlet="tableTemplate; context: { $implicit: table.CHILD, level: level + 1 }"></ng-container>
              </div>
            </div>
          </ng-template>
          
        <div class="json-preview">
            <h3>JSON Gerado</h3>
            <div class="json-buttons">
                <button mat-stroked-button color="primary" (click)="enableJsonEdit()">Editar JSON</button>
                <button mat-stroked-button color="accent" (click)="copyJson(true)">Copiar JSON</button>
             </div>
            <div *ngIf="!editingJson">
              <pre>{{ getFormattedJSON() }}</pre>
              
            </div>

            <div *ngIf="editingJson">
              <mat-form-field appearance="outline" class="json-editor-field">
                <textarea
                  matInput
                  rows="20"
                  [(ngModel)]="jsonEditorText"
                  placeholder="Edite o JSON diretamente aqui..."></textarea>
              </mat-form-field>

              <div class="json-actions">
                <button mat-stroked-button color="warn" (click)="cancelJsonEdit()">Cancelar</button>
                <button mat-raised-button color="primary" (click)="applyJsonEdit()">Aplicar</button>
              </div>

              <div *ngIf="jsonParseError" class="json-error">
                ⚠️ JSON inválido: {{ jsonParseError }}
              </div>
            </div>
          </div>

    </div> 
  </mat-dialog-content>
  <mat-dialog-actions class="dialog-actions"  style="justify-content: flex-end;">
  <button mat-raised-button color="warn" mat-dialog-close>CANCELAR</button>
  <button mat-raised-button color="primary" [mat-dialog-close]="{config: this.config, file: this.selectedFile, name: configName}"
   cdkFocusInitial>OK</button>
  
</mat-dialog-actions>